import { ArrowClockwiseIcon } from '@phosphor-icons/react';

import { TextButton } from '@/components/common/text-button';

import styles from './region-error.module.scss';

export type RegionErrorProps = {
  /** What failed, in the house `We couldn't load your <thing>. Please try again.` voice. */
  message: string;
  onRetry: () => void;
};

/**
 * One region's failure state: the notice and the retry that re-requests **only that region**.
 *
 * The Map's two layers are two independent queries (113586 §15b/§15c), so a Device-layer failure draws
 * this over a canvas that is still showing Boundaries — the notice names the layer and never implies
 * that anything was removed from the account, nor that the Grower has nothing mapped (113587 §8b).
 *
 * Named for the one state it renders. It owns no loading state and never will: each region's skeleton
 * has to occupy that region's own shape, and a map canvas has nothing to share with a card grid.
 */
export function RegionError({ message, onRetry }: RegionErrorProps) {
  return (
    <div className={styles.notice}>
      <p className={styles.noticeText}>{message}</p>
      <TextButton
        tone="brand"
        size="sm"
        startIcon={<ArrowClockwiseIcon size={16} />}
        onClick={onRetry}
      >
        Try again
      </TextButton>
    </div>
  );
}
